import * as React from 'react';
import Block from "@layout/Block";
import './index.scss';

interface Props {
    children?: React.ReactNode;
    onClick?: () => void;
    type?: string;
    hintHide?: boolean;
}

const ButtonNext = ({ onClick, children, type = 'button', hintHide }: Props) => (
    <div className="button-next-wrapper">
        <Block indent="5">
            <button type={type} className="btn-next" onClick={onClick}>{children}</button>
        </Block>
        {
            !hintHide && <div className="hint">or press ENTER</div>
        }
        
    </div>
);

export default ButtonNext;


// WEBPACK FOOTER //
// ./src/components/layout/buttons/Next/index.tsx